module.exports = __webpack_public_path__ + "static/media/order_icon23.03ee8d40.png";